var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "div",
        { staticClass: "page-header-wrapper padding-rb" },
        [
          _c(
            "PageHeader",
            { attrs: { title: `${_vm.title} Customer List` } },
            [
              _c("el-input", {
                directives: [
                  {
                    name: "debounce",
                    rawName: "v-debounce",
                    value: _vm.onSearch,
                    expression: "onSearch",
                  },
                ],
                attrs: {
                  "prefix-icon": "el-icon-search",
                  placeholder: "Search",
                  clearable: "",
                },
                on: { clear: _vm.onSearch },
                model: {
                  value: _vm.searchVal,
                  callback: function ($$v) {
                    _vm.searchVal = $$v
                  },
                  expression: "searchVal",
                },
              }),
              _c("import-button", {
                directives: [
                  {
                    name: "role",
                    rawName: "v-role",
                    value: [1],
                    expression: "[1]",
                  },
                ],
                attrs: { action: `/customer/importRelation/${_vm.roleType}` },
                on: {
                  success: function ($event) {
                    return _vm.getTableData()
                  },
                },
              }),
              _c(
                "el-dropdown",
                {
                  directives: [
                    {
                      name: "role",
                      rawName: "v-role",
                      value: [1],
                      expression: "[1]",
                    },
                  ],
                  attrs: { trigger: "click" },
                  on: { command: _vm.handleCommand },
                },
                [
                  _c("el-button", { attrs: { type: "primary" } }, [
                    _vm._v(" Export "),
                    _c("i", {
                      staticClass: "el-icon-arrow-down el-icon--right",
                    }),
                  ]),
                  _c(
                    "el-dropdown-menu",
                    {
                      staticClass: "export-dropdown",
                      attrs: { slot: "dropdown" },
                      slot: "dropdown",
                    },
                    [
                      _c(
                        "el-dropdown-item",
                        {
                          attrs: {
                            icon: "el-icon-download",
                            command: "leader",
                            disabled: _vm.disableExportLeader,
                          },
                        },
                        [_vm._v(" " + _vm._s(_vm.title) + " User ")]
                      ),
                      _c(
                        "el-dropdown-item",
                        {
                          attrs: {
                            icon: "el-icon-download",
                            command: "customer",
                            disabled: _vm.disableExportSEUser,
                          },
                        },
                        [_vm._v(" Customer User ")]
                      ),
                      _c(
                        "el-dropdown-item",
                        {
                          attrs: {
                            icon: "el-icon-download",
                            command: "template",
                          },
                        },
                        [_vm._v(" Import Template ")]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "table-wrapper" },
        [
          _c(
            "el-table",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.tableLoading,
                  expression: "tableLoading",
                },
              ],
              ref: "table",
              attrs: {
                data: _vm.tableData,
                "element-loading-text": "Loading...",
              },
              on: { "sort-change": _vm.onSortChange },
            },
            [
              _c("el-table-column", {
                attrs: {
                  prop: "SEName",
                  label: "Customer Name",
                  "min-width": "160",
                  sortable: "custom",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "City",
                  label: "City",
                  "min-width": "80",
                  sortable: "custom",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "hospital",
                  label: "Hospital / Institution",
                  "min-width": "180",
                  sortable: "custom",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "Department",
                  label: "Department",
                  "min-width": "140",
                  sortable: "custom",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "MLName",
                  label: _vm.title,
                  "min-width": "100",
                  sortable: "custom",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "span",
                          { staticStyle: { "margin-right": "10px" } },
                          [_vm._v(_vm._s(scope.row.MLName))]
                        ),
                        scope.row.LeaderTotal > 0
                          ? _c(
                              "el-popover",
                              {
                                attrs: {
                                  "popper-class": "leader-list-popover",
                                  trigger: "hover",
                                  placement: "bottom-end",
                                },
                                on: {
                                  show: function ($event) {
                                    return _vm.onLeaderShow(
                                      scope.$index,
                                      scope.row
                                    )
                                  },
                                },
                              },
                              [
                                _c(
                                  "div",
                                  {
                                    directives: [
                                      {
                                        name: "loading",
                                        rawName: "v-loading",
                                        value: scope.row.loading,
                                        expression: "scope.row.loading",
                                      },
                                    ],
                                    staticClass: "leader-list",
                                    class: { loading: scope.row.loading },
                                    attrs: {
                                      "element-loading-text": "Loading...",
                                    },
                                  },
                                  [
                                    _c(
                                      "div",
                                      { staticClass: "leader-header" },
                                      [
                                        _c("span", { staticClass: "name" }, [
                                          _c("strong", [
                                            _vm._v(_vm._s(_vm.title) + " Name"),
                                          ]),
                                        ]),
                                        _c("span", { staticClass: "team" }, [
                                          _c("strong", [_vm._v("Team")]),
                                        ]),
                                      ]
                                    ),
                                    _vm._l(
                                      scope.row.leaders,
                                      function (item, i) {
                                        return _c(
                                          "div",
                                          {
                                            key: i,
                                            staticClass: "leader-item",
                                          },
                                          [
                                            _c(
                                              "span",
                                              { staticClass: "name" },
                                              [_vm._v(_vm._s(item.LeaderName))]
                                            ),
                                            _c(
                                              "span",
                                              { staticClass: "team" },
                                              [_vm._v(_vm._s(item.TeamName))]
                                            ),
                                          ]
                                        )
                                      }
                                    ),
                                  ],
                                  2
                                ),
                                _c(
                                  "el-tag",
                                  {
                                    staticClass: "crp-more",
                                    attrs: {
                                      slot: "reference",
                                      type: "warning",
                                      effect: "dark",
                                    },
                                    slot: "reference",
                                  },
                                  [
                                    _vm._v(
                                      " " + _vm._s(scope.row.LeaderTotal) + " "
                                    ),
                                    _c("i", {
                                      staticClass: "el-icon-arrow-down",
                                    }),
                                  ]
                                ),
                              ],
                              1
                            )
                          : _vm._e(),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "Certified",
                  width: "110",
                  label: "Certified",
                  sortable: "custom",
                },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "default",
                      fn: function ({ row }) {
                        return !row.isChildren
                          ? [
                              _c(
                                "el-tag",
                                {
                                  attrs: {
                                    type: _vm.tagTypeParser(row.Active),
                                    effect: "dark",
                                  },
                                },
                                [
                                  _vm._v(
                                    " " +
                                      _vm._s(_vm.tagLabelParser(row.Active)) +
                                      " "
                                  ),
                                ]
                              ),
                            ]
                          : undefined
                      },
                    },
                  ],
                  null,
                  true
                ),
              }),
              _c("el-table-column", {
                attrs: {
                  label: "Operation",
                  width: "100",
                  prop: "StatusDesc",
                  align: "center",
                },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "default",
                      fn: function ({ row }) {
                        return !row.isChildren
                          ? [
                              _c(
                                "el-button",
                                {
                                  attrs: { type: "text", icon: "el-icon-edit" },
                                  on: {
                                    click: function ($event) {
                                      return _vm.handleEdit(row)
                                    },
                                  },
                                },
                                [_vm._v(" Edit ")]
                              ),
                            ]
                          : undefined
                      },
                    },
                  ],
                  null,
                  true
                ),
              }),
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "pagination-wrap" },
            [
              _c("el-pagination", {
                attrs: {
                  "current-page": _vm.currentPage,
                  "pager-count": _vm.pagerCount,
                  "page-sizes": [10, 25, 50, 100],
                  "page-size": _vm.pageSize,
                  layout: "total, sizes, prev, pager, next, jumper",
                  total: _vm.total,
                },
                on: {
                  "size-change": _vm.handleSizeChange,
                  "current-change": _vm.handleCurrentChange,
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c("EditCustomerDialog", {
        attrs: {
          visible: _vm.editSEDialogVisible,
          "role-type": _vm.roleType,
          title: _vm.title,
          data: _vm.rowData,
        },
        on: {
          "update:visible": function ($event) {
            _vm.editSEDialogVisible = $event
          },
          "update:data": function ($event) {
            _vm.rowData = $event
          },
          success: _vm.getTableData,
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }